import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import debounce from 'lodash/debounce';
import { CHECK_ALL_SPEACH_FROM_BACK, CHECK_ALL_SPEACH_NOT_CHECKED, CHECK_SPEACH, COPY_SPEACH_SEARCH_FILTERS, EMPTY_SPEACH_LIST, GET_SPEACH_FROM_SPEACH_ID, REFRESH_CHECKED_SPEACH_TO_SHOW, REFRESH_COUR_IN_CHECKED_LIST, SPEACH_IDS_LIST, SPEACH_LIST, UNCHECK_ALL_SPEACH_FROM_BACK, UNCHECK_ALL_SPEACH_IN_SEARCH_LIST, UNCHECK_SPEACH } from '@/store/actions/speach';
import { v4 as uuidv4 } from 'uuid';
import SpeachTable from '@/components/platform/copySpeach/SpeachTable.vue';
import InfiniteLoading from 'vue-infinite-loading';
import Banner from "@/components/banner/Banner.vue";
var ChooseSpeach = /*#__PURE__*/function (_Vue) {
  function ChooseSpeach() {
    var _this;
    _classCallCheck(this, ChooseSpeach);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChooseSpeach, [].concat(args));
    _defineProperty(_this, "checkAllMessage", false);
    _defineProperty(_this, "uncheckAllMessage", false);
    _defineProperty(_this, "infiniteLoaderID", uuidv4());
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "debounceInfinite", debounce(function (state) {
      if (_this.totalNumber <= _this.listSpeach.length) {
        state.complete();
        state.loaded();
      } else {
        _this.infiniteHandler(state);
      }
    }, 250));
    return _this;
  }
  _inherits(ChooseSpeach, _Vue);
  return _createClass(ChooseSpeach, [{
    key: "listSpeach",
    get:
    // -- Computed variables
    function get() {
      return store.getters.listSpeach;
    }
  }, {
    key: "listCheckedSpeach",
    get: function get() {
      return store.getters.listCheckedSpeach;
    }
  }, {
    key: "listCheckedSpeachSearchList",
    get: function get() {
      return store.getters.listCheckedSpeachSearchList;
    }
  }, {
    key: "currentPage",
    get: function get() {
      return store.getters.currentPageSpeach;
    }
  }, {
    key: "totalNumber",
    get: function get() {
      return store.getters.totalNumberSpeach;
    }
  }, {
    key: "sourcePlatform",
    get: function get() {
      return store.getters.sourcePlatform;
    }
  }, {
    key: "sourceCategories",
    get: function get() {
      return store.getters.categories(this.sourcePlatform.platformID);
    }
  }, {
    key: "searchFilters",
    get: function get() {
      return store.getters.copySpeachSearchFilters;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this$listSpeach,
        _this2 = this;
      if (!((_this$listSpeach = this.listSpeach) !== null && _this$listSpeach !== void 0 && _this$listSpeach.length)) {
        this.loading = true;
        this.searchSpeach().then(function () {
          return _this2.loading = false;
        });
      }
    }
  }, {
    key: "filterTitle",
    value: function () {
      var _filterTitle = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(titleFilter) {
        var _this$searchFilters, _this$searchFilters2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.filter(titleFilter, (_this$searchFilters = this.searchFilters) === null || _this$searchFilters === void 0 ? void 0 : _this$searchFilters.author, (_this$searchFilters2 = this.searchFilters) === null || _this$searchFilters2 === void 0 ? void 0 : _this$searchFilters2.category);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function filterTitle(_x) {
        return _filterTitle.apply(this, arguments);
      }
      return filterTitle;
    }()
  }, {
    key: "filterAuthor",
    value: function () {
      var _filterAuthor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(authorFilter) {
        var _this$searchFilters3, _this$searchFilters4;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.filter((_this$searchFilters3 = this.searchFilters) === null || _this$searchFilters3 === void 0 ? void 0 : _this$searchFilters3.title, authorFilter, (_this$searchFilters4 = this.searchFilters) === null || _this$searchFilters4 === void 0 ? void 0 : _this$searchFilters4.category);
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function filterAuthor(_x2) {
        return _filterAuthor.apply(this, arguments);
      }
      return filterAuthor;
    }()
  }, {
    key: "filterCategory",
    value: function () {
      var _filterCategory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(categoryFilter) {
        var _this$sourceCategorie, _this$searchFilters5, _this$searchFilters6;
        var categoryFilterId, category;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              categoryFilterId = categoryFilter === null || categoryFilter === void 0 ? void 0 : categoryFilter.id;
              category = (_this$sourceCategorie = this.sourceCategories) === null || _this$sourceCategorie === void 0 ? void 0 : _this$sourceCategorie.find(function (c) {
                return c.id === categoryFilterId;
              });
              _context3.n = 1;
              return this.filter((_this$searchFilters5 = this.searchFilters) === null || _this$searchFilters5 === void 0 ? void 0 : _this$searchFilters5.title, (_this$searchFilters6 = this.searchFilters) === null || _this$searchFilters6 === void 0 ? void 0 : _this$searchFilters6.author, category);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function filterCategory(_x3) {
        return _filterCategory.apply(this, arguments);
      }
      return filterCategory;
    }()
  }, {
    key: "filter",
    value: function () {
      var _filter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(filteredTitle, filteredAuthor, filteredCategory) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return store.dispatch(COPY_SPEACH_SEARCH_FILTERS, {
                title: filteredTitle,
                author: filteredAuthor,
                category: filteredCategory
              });
            case 1:
              _context4.n = 2;
              return this.searchSpeach();
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function filter(_x4, _x5, _x6) {
        return _filter.apply(this, arguments);
      }
      return filter;
    }()
  }, {
    key: "check",
    value: function () {
      var _check = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(checkedList, row) {
        var indexOfRow;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!row) {
                _context5.n = 4;
                break;
              }
              this.checkAllMessage = false;
              this.uncheckAllMessage = false;
              indexOfRow = checkedList.findIndex(function (c) {
                return c.speachID === row.speachID;
              });
              if (!(indexOfRow != -1)) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return store.dispatch(CHECK_SPEACH, row);
            case 1:
              _context5.n = 3;
              break;
            case 2:
              _context5.n = 3;
              return store.dispatch(UNCHECK_SPEACH, row);
            case 3:
              _context5.n = 4;
              return store.dispatch(REFRESH_CHECKED_SPEACH_TO_SHOW);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function check(_x7, _x8) {
        return _check.apply(this, arguments);
      }
      return check;
    }()
  }, {
    key: "allCheck",
    value: function () {
      var _allCheck = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(checkedList) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.uncheckAllMessage = false;
              if (!((checkedList === null || checkedList === void 0 ? void 0 : checkedList.length) > 0)) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return store.dispatch(CHECK_ALL_SPEACH_NOT_CHECKED, checkedList);
            case 1:
              this.checkAllMessage = true;
              _context6.n = 3;
              break;
            case 2:
              this.checkAllMessage = false;
              _context6.n = 3;
              return store.dispatch(UNCHECK_ALL_SPEACH_IN_SEARCH_LIST);
            case 3:
              _context6.n = 4;
              return store.dispatch(REFRESH_CHECKED_SPEACH_TO_SHOW);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function allCheck(_x9) {
        return _allCheck.apply(this, arguments);
      }
      return allCheck;
    }()
  }, {
    key: "selectAllFromBack",
    value: function () {
      var _selectAllFromBack = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this$searchFilters7, _this$searchFilters8, _this$searchFilters9;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.checkAllMessage = false;
              this.uncheckAllMessage = true;
              _context7.n = 1;
              return store.dispatch(SPEACH_IDS_LIST, {
                platformID: this.sourcePlatform.platformID,
                title: (_this$searchFilters7 = this.searchFilters) === null || _this$searchFilters7 === void 0 ? void 0 : _this$searchFilters7.title,
                author: (_this$searchFilters8 = this.searchFilters) === null || _this$searchFilters8 === void 0 ? void 0 : _this$searchFilters8.author,
                categoryId: (_this$searchFilters9 = this.searchFilters) === null || _this$searchFilters9 === void 0 || (_this$searchFilters9 = _this$searchFilters9.category) === null || _this$searchFilters9 === void 0 ? void 0 : _this$searchFilters9.id
              });
            case 1:
              _context7.n = 2;
              return store.dispatch(CHECK_ALL_SPEACH_FROM_BACK);
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function selectAllFromBack() {
        return _selectAllFromBack.apply(this, arguments);
      }
      return selectAllFromBack;
    }()
  }, {
    key: "clearAllFromBack",
    value: function () {
      var _clearAllFromBack = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              this.checkAllMessage = false;
              this.uncheckAllMessage = false;
              _context8.n = 1;
              return store.dispatch(UNCHECK_ALL_SPEACH_FROM_BACK);
            case 1:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function clearAllFromBack() {
        return _clearAllFromBack.apply(this, arguments);
      }
      return clearAllFromBack;
    }()
  }, {
    key: "checkFromSelectedList",
    value: function () {
      var _checkFromSelectedList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(checkedList, row) {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return this.check(checkedList, row);
            case 1:
              _context9.n = 2;
              return store.dispatch(REFRESH_CHECKED_SPEACH_TO_SHOW);
            case 2:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function checkFromSelectedList(_x0, _x1) {
        return _checkFromSelectedList.apply(this, arguments);
      }
      return checkFromSelectedList;
    }()
  }, {
    key: "refreshCourAndAddToListChecked",
    value: function () {
      var _refreshCourAndAddToListChecked = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(row) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              store.dispatch(GET_SPEACH_FROM_SPEACH_ID, {
                platformID: this.sourcePlatform.platformID,
                speachID: row.speachID
              }).then(function (cour) {
                if (cour) {
                  store.dispatch(REFRESH_COUR_IN_CHECKED_LIST, cour);
                }
              });
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function refreshCourAndAddToListChecked(_x10) {
        return _refreshCourAndAddToListChecked.apply(this, arguments);
      }
      return refreshCourAndAddToListChecked;
    }()
  }, {
    key: "searchSpeach",
    value: function () {
      var _searchSpeach = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var page,
          append,
          _this$searchFilters0,
          _this$searchFilters1,
          _this$searchFilters10,
          _args1 = arguments;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              page = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : 1;
              append = _args1.length > 1 && _args1[1] !== undefined ? _args1[1] : false;
              this.checkAllMessage = false;
              this.uncheckAllMessage = false;
              if (!this.sourcePlatform) {
                _context1.n = 2;
                break;
              }
              _context1.n = 1;
              return store.dispatch(SPEACH_LIST, {
                platformID: this.sourcePlatform.platformID,
                title: (_this$searchFilters0 = this.searchFilters) === null || _this$searchFilters0 === void 0 ? void 0 : _this$searchFilters0.title,
                author: (_this$searchFilters1 = this.searchFilters) === null || _this$searchFilters1 === void 0 ? void 0 : _this$searchFilters1.author,
                categoryId: (_this$searchFilters10 = this.searchFilters) === null || _this$searchFilters10 === void 0 || (_this$searchFilters10 = _this$searchFilters10.category) === null || _this$searchFilters10 === void 0 ? void 0 : _this$searchFilters10.id,
                page: page,
                append: append
              });
            case 1:
              _context1.n = 3;
              break;
            case 2:
              _context1.n = 3;
              return store.dispatch(EMPTY_SPEACH_LIST);
            case 3:
              //if we don't append the search, it is a new one, so we have to reset the infinite handler
              if (!append) {
                this.resetInfiniteHandler();
              }
              _context1.n = 4;
              return store.dispatch(REFRESH_CHECKED_SPEACH_TO_SHOW);
            case 4:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function searchSpeach() {
        return _searchSpeach.apply(this, arguments);
      }
      return searchSpeach;
    }() //We need to reset the infinite handler when we perform a new search.
  }, {
    key: "resetInfiniteHandler",
    value: function resetInfiniteHandler() {
      //The easiest way to reset the infinite handler is to change its id
      this.infiniteLoaderID = uuidv4();
    }
  }, {
    key: "infiniteHandler",
    value: function infiniteHandler(state) {
      var _this3 = this;
      this.searchSpeach(this.currentPage + 1, true).then(function () {
        if (_this3.totalNumber <= _this3.listSpeach.length) {
          state.complete();
        }
        state.loaded();
      }).catch(function () {
        state.complete();
      });
    }
  }, {
    key: "goToPlatform",
    value: function goToPlatform(url) {
      window.open(url, '_blank');
    }
  }]);
}(Vue);
ChooseSpeach = __decorate([Options({
  components: {
    SpeachTable: SpeachTable,
    InfiniteLoading: InfiniteLoading,
    Banner: Banner
  }
})], ChooseSpeach);
export default ChooseSpeach;